import { Dispatch } from "redux";
import { UserToken, SET_TOKEN } from "types/actions/Token.actions";

export const setToken = (token: any) => {
  return (dispatch: Dispatch<UserToken>) => {
    dispatch({ type: SET_TOKEN, token: token });
  };
};
